/* eslint-disable react/display-name */
import React, { memo } from "react";
import UserInputMessageAreaSupport from "./userInputMessageAreaSupport";

const SupportBoardFooter = (props) => {
  const userInputMessageProps = { ...props, componentType: "footer" };
  return (
    <>
      <UserInputMessageAreaSupport {...userInputMessageProps} />
    </>
  );
};

export default memo(SupportBoardFooter);
